import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '@digdir/designsystemet-react';
import { Routes } from '../../enums/Routes';
import { buildRoute } from '../../utils/routeBuilder';
import { useCreateCustomSurveyTemplateMutation } from '../../hooks/mutations/useCreateCustomSurveyTemplateMutation';
import { TemplateForm } from './components/TemplateForm';
import { emptyDraft } from './templateDraft';
import classes from './CreateCustomSurveyTemplatePage.module.css';

export const CreateCustomSurveyTemplatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [initialDraft] = useState(emptyDraft);

  const createMutation = useCreateCustomSurveyTemplateMutation({
    onSuccess: (template) =>
      navigate(buildRoute(Routes.CustomSurveyTemplateDetail, { templateId: template.id }), { state: { created: true } }),
  });

  return (
    <TemplateForm
      mode="create"
      initialDraft={initialDraft}
      crumbs={[
        { label: t('customSurveys.templateDetail.breadcrumb'), to: Routes.CustomSurveyTemplates },
        { label: t('customSurveys.create.newTemplate'), to: Routes.CreateCustomSurveyTemplate },
      ]}
      eyebrow={t('customSurveys.create.newTemplate')}
      fallbackTitle={t('customSurveys.create.newTemplate')}
      intro={
        <Paragraph data-size="md" className={`${classes.subtle} ${classes.introText}`}>
          {t('customSurveys.create.description')}
        </Paragraph>
      }
      submitLabel={t('customSurveys.create.submit')}
      isPending={createMutation.isPending}
      saveFailed={createMutation.isError}
      cancelTo={Routes.CustomSurveyTemplates}
      onSubmit={(request) => createMutation.mutate(request)}
    />
  );
};
